// import React, { useState } from 'react';
// import { PageTitle, Card, Button } from '../components/common';
// import { mockAttendanceRecords } from '../mockData';
// import { AttendanceRecord } from '../types';
// import { useToast } from '../components/Toaster';

// // Icons
// const CheckCircleIcon = () => <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path></svg>;
// const InfoIcon = () => <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"></path></svg>;
// const ClockIcon = () => <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd"></path></svg>;
// const PlusIcon = () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" /></svg>;
// const XIcon = () => <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>;

// const StatusBadge: React.FC<{ status: AttendanceRecord['status'] }> = ({ status }) => {
//     const styles = {
//         Present: { classes: 'bg-green-100 text-green-700', icon: <CheckCircleIcon /> },
//         Leave: { classes: 'bg-yellow-100 text-yellow-800', icon: <InfoIcon /> },
//         Partial: { classes: 'bg-blue-100 text-blue-800', icon: <ClockIcon /> },
//     };
//     const { classes, icon } = styles[status];
//     return (
//         <span className={`inline-flex items-center px-3 py-1 text-xs font-semibold rounded-full ${classes}`}>
//             {icon}
//             {status}
//         </span>
//     );
// };

// const MarkAttendanceModal: React.FC<{
//     isOpen: boolean;
//     onClose: () => void;
//     onMarkAttendance: (newRecord: Omit<AttendanceRecord, 'id'>) => void;
// }> = ({ isOpen, onClose, onMarkAttendance }) => {
//     const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
//     const [startTime, setStartTime] = useState('09:00');
//     const [endTime, setEndTime] = useState('17:00');
//     const [status, setStatus] = useState<AttendanceRecord['status']>('Present');
//     const [reason, setReason] = useState('');

//     const handleSubmit = (e: React.FormEvent) => {
//         e.preventDefault();
//         onMarkAttendance({ 
//             date: new Date(date).toISOString(), 
//             startTime: status === 'Present' || status === 'Partial' ? startTime : undefined,
//             endTime: status === 'Present' || status === 'Partial' ? endTime : undefined,
//             status, 
//             reason: status !== 'Present' ? reason : undefined 
//         });
//         onClose();
//         // Reset form to defaults
//         setDate(new Date().toISOString().split('T')[0]);
//         setStartTime('09:00');
//         setEndTime('17:00');
//         setStatus('Present');
//         setReason('');
//     };

//     if (!isOpen) return null;

//     return (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
//             <div className="bg-white rounded-xl shadow-xl w-full max-w-lg" onClick={e => e.stopPropagation()}>
//                 <form onSubmit={handleSubmit}>
//                     <header className="flex justify-between items-center p-5 border-b border-gray-200">
//                         <h2 className="text-xl font-bold text-gray-900">Mark Today's Attendance</h2>
//                         <button type="button" onClick={onClose} className="p-1 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600">
//                             <XIcon />
//                         </button>
//                     </header>
//                     <div className="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
//                         <div>
//                             <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1">Date</label>
//                             <input type="date" id="date" value={date} onChange={e => setDate(e.target.value)} required className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary" />
//                         </div>
                        
//                         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                            <div>
//                                 <label htmlFor="startTime" className="block text-sm font-medium text-gray-700 mb-1">Start Time</label>
//                                 <input type="time" id="startTime" value={startTime} onChange={e => setStartTime(e.target.value)} required={status !== 'Leave'} disabled={status === 'Leave'} className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary disabled:bg-gray-100" />
//                             </div>
//                             <div>
//                                 <label htmlFor="endTime" className="block text-sm font-medium text-gray-700 mb-1">End Time</label>
//                                 <input type="time" id="endTime" value={endTime} onChange={e => setEndTime(e.target.value)} required={status !== 'Leave'} disabled={status === 'Leave'} className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary disabled:bg-gray-100" />
//                             </div>
//                         </div>

//                         <div>
//                             <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1">Status</label>
//                             <select id="status" value={status} onChange={e => setStatus(e.target.value as any)} className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary">
//                                 <option>Present</option>
//                                 <option>Leave</option>
//                                 <option>Partial</option>
//                             </select>
//                         </div>
                        
//                         {(status === 'Leave' || status === 'Partial') && (
//                              <div className="transition-all duration-300 ease-in-out">
//                                 <label htmlFor="reason" className="block text-sm font-medium text-gray-700 mb-1">Reason</label>
//                                 <textarea id="reason" value={reason} onChange={e => setReason(e.target.value)} required rows={3} className="w-full p-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary" placeholder="e.g., Doctor's appointment, family emergency..."></textarea>
//                             </div>
//                         )}
//                     </div>
//                     <footer className="p-4 bg-gray-50 border-t border-gray-200 flex justify-end gap-3 rounded-b-xl">
//                         <Button type="button" variant="secondary" onClick={onClose}>Cancel</Button>
//                         <Button type="submit">Mark Attendance</Button>
//                     </footer>
//                 </form>
//             </div>
//         </div>
//     );
// };

// const AttendancePage: React.FC = () => {
//     const [records, setRecords] = useState<AttendanceRecord[]>(mockAttendanceRecords);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const toast = useToast();

//     const handleMarkAttendance = (newRecordData: Omit<AttendanceRecord, 'id'>) => {
//         const newRecord: AttendanceRecord = {
//             id: `att${records.length + 1}`,
//             ...newRecordData,
//         };
//         setRecords(prev => [newRecord, ...prev].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()));
//         toast.success("Attendance marked successfully!");
//     };

//     const formatDate = (dateString: string) => new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
//     const getDayOfWeek = (dateString:string) => new Date(dateString).toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' });

//     return (
//         <div>
//             <PageTitle title="My Attendance" subtitle="Here is a summary of your attendance records.">
//                 {/* <Button onClick={() => setIsModalOpen(true)}>
//                     <PlusIcon /> Mark Today’s Attendance
//                 </Button> */}
//             </PageTitle>

//             <Card className="overflow-hidden">
//                 <div className="overflow-x-auto">
//                     <table className="w-full text-sm text-left">
//                         <thead className="text-xs text-gray-700 uppercase bg-gray-50 font-semibold">
//                             <tr>
//                                 <th scope="col" className="px-6 py-4">Date</th>
//                                 <th scope="col" className="px-6 py-4 hidden sm:table-cell">Day</th>
//                                 <th scope="col" className="px-6 py-4 hidden md:table-cell">Start Time</th>
//                                 <th scope="col" className="px-6 py-4 hidden md:table-cell">End Time</th>
//                                 <th scope="col" className="px-6 py-4">Status</th>
//                                 <th scope="col" className="px-6 py-4">Reason</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {records.map((record) => (
//                                 <tr key={record.id} className="bg-white border-b last:border-b-0 hover:bg-gray-50">
//                                     <td className="px-6 py-4 font-medium text-gray-800 whitespace-nowrap">{formatDate(record.date)}</td>
//                                     <td className="px-6 py-4 text-gray-600 hidden sm:table-cell">{getDayOfWeek(record.date)}</td>
//                                     <td className="px-6 py-4 text-gray-600 hidden md:table-cell">{record.startTime || '—'}</td>
//                                     <td className="px-6 py-4 text-gray-600 hidden md:table-cell">{record.endTime || '—'}</td>
//                                     <td className="px-6 py-4"><StatusBadge status={record.status} /></td>
//                                     <td className="px-6 py-4 text-gray-600 truncate max-w-xs">{record.reason || '—'}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </Card>

//             <MarkAttendanceModal 
//                 isOpen={isModalOpen}
//                 onClose={() => setIsModalOpen(false)}
//                 onMarkAttendance={handleMarkAttendance}
//             />
//         </div>
//     );
// };

import React, { useState, useEffect } from 'react';
import { PageTitle, Card, Button } from '../components/common';
import { AttendanceRecord } from '../types';
import { useToast } from '../components/Toaster';
import { getTraineeAttendance, getTraineeBatchDetails } from '../services/api';

// Icons
const CheckCircleIcon = () => <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path></svg>;
const XCircleIcon = () => <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd"></path></svg>;
const ClockIcon = () => <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd"></path></svg>;
const CalendarIcon = () => <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>;

const StatusBadge: React.FC<{ status: 'Present' | 'Absent' | 'Partial' | 'Leave' }> = ({ status }) => {
    const styles = {
        Present: { classes: 'bg-green-100 text-green-700 border border-green-200', icon: <CheckCircleIcon /> },
        Absent: { classes: 'bg-red-100 text-red-700 border border-red-200', icon: <XCircleIcon /> },
        Leave: { classes: 'bg-yellow-100 text-yellow-800 border border-yellow-200', icon: <XCircleIcon /> },
        Partial: { classes: 'bg-blue-100 text-blue-800 border border-blue-200', icon: <ClockIcon /> },
    };
    const { classes, icon } = styles[status];
    return (
        <span className={`inline-flex items-center px-3 py-1 text-xs font-semibold rounded-full ${classes}`}>
            {icon}
            {status}
        </span>
    );
};

interface ApiAttendanceRecord {
    date: string;
    day: string;
    startTime: string;
    endTime: string;
    status: 'Present' | 'Absent' | 'Partial' | 'Leave';
    reason: string;
}

interface ApiResponse {
    success: boolean;
    trainee: string;
    totalRecords: number;
    attendance: ApiAttendanceRecord[];
}

const AttendancePage: React.FC = () => {
    const [records, setRecords] = useState<ApiAttendanceRecord[]>([]);
    const [filteredRecords, setFilteredRecords] = useState<ApiAttendanceRecord[]>([]);
    const [traineeName, setTraineeName] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const itemsPerPage = 15;
    const [selectedMonth, setSelectedMonth] = useState<number>(new Date().getMonth());
    const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());
    const [selectedStatus, setSelectedStatus] = useState<string>('All');
    const [isProgramCompleted, setIsProgramCompleted] = useState<boolean>(false);
    const toast = useToast();

    // Generate months and years for filters
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => currentYear - 2 + i);

    // Fetch attendance data on component mount
    useEffect(() => {
        const fetchAttendance = async () => {
            try {
                setLoading(true);
                setError(null);
                
                const traineeToken = localStorage.getItem('TraineeToken');
                if (!traineeToken) {
                    setError('Trainee token not found. Please login again.');
                    setLoading(false);
                    return;
                }

                const response: ApiResponse = await getTraineeAttendance(traineeToken);
                console.log("API Response:", response);
                
                if (response && response.success && Array.isArray(response.attendance)) {
                    // Set all data from API response
                    setRecords(response.attendance);
                    setFilteredRecords(response.attendance);
                    setTraineeName(response.trainee || '');
                    setTotalRecords(response.totalRecords || response.attendance.length);
                    console.log("Records set:", response.attendance.length, "records for", response.trainee);
                } else {
                    console.log("No valid attendance data found");
                    setRecords([]);
                    setFilteredRecords([]);
                    setTraineeName('');
                    setTotalRecords(0);
                }
                
            } catch (err) {
                const errorMessage = err instanceof Error ? err.message : 'Failed to fetch attendance records';
                setError(errorMessage);
                console.error("Error fetching attendance:", err);
                if (!errorMessage.includes('token')) {
                    toast.error(errorMessage);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchAttendance();
    }, [toast]);

    // Filter records when month or year changes - FIXED TIMEZONE ISSUE
    useEffect(() => {
        if (records.length === 0) return;

        // Skip filtering if in history mode (program completed)
        if (isProgramCompleted) {
            setFilteredRecords(records);
            return;
        }

        const filtered = records.filter(record => {
            // First check status
            if (selectedStatus !== 'All' && record.status !== selectedStatus) return false;
            
            // Skip month/year filtering if in history mode (program completed)
            if (isProgramCompleted) return true;

            try {
                // Parse date without timezone conversion
                const [month, day, year] = record.date.split(' ');
                const monthIndex = months.findIndex(m => m === month);
                if (monthIndex === -1) return false;
                
                const recordDate = new Date(parseInt(year), monthIndex, parseInt(day.replace(',', '')));
                return (
                    recordDate.getMonth() === selectedMonth &&
                    recordDate.getFullYear() === selectedYear
                );
            } catch (error) {
                console.error("Error parsing date:", record.date, error);
                return false;
            }
        });

        setFilteredRecords(filtered);
        setCurrentPage(1); // Reset page when filters change
    }, [selectedMonth, selectedYear, selectedStatus, records, months, isProgramCompleted]);

    // Check for program completion
    useEffect(() => {
        const checkProgramStatus = async () => {
            try {
                const traineeToken = localStorage.getItem('TraineeToken');
                if (!traineeToken) return;

                const response = await getTraineeBatchDetails(traineeToken);
                if (response && response.batches && response.batches.length > 0) {
                    const latestBatch = response.batches[0];
                    const endDate = new Date(latestBatch.endDate).getTime();
                    const now = new Date().getTime();
                    
                    if (now > endDate) {
                        setIsProgramCompleted(true);
                        // In history mode, we show everything by default
                        setFilteredRecords(records);
                    }
                }
            } catch (error) {
                console.error("Error checking program status:", error);
            }
        };

        checkProgramStatus();
    }, [records]);

    const handleRetry = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const traineeToken = localStorage.getItem('TraineeToken');
            if (!traineeToken) {
                setError('Trainee token not found. Please login again.');
                setLoading(false);
                return;
            }

            const response: ApiResponse = await getTraineeAttendance(traineeToken);
            console.log("Retry Response:", response);
            
            if (response && response.success && Array.isArray(response.attendance)) {
                setRecords(response.attendance);
                setFilteredRecords(response.attendance);
                setTraineeName(response.trainee || '');
                setTotalRecords(response.totalRecords || response.attendance.length);
            } else {
                setRecords([]);
                setFilteredRecords([]);
                setTraineeName('');
                setTotalRecords(0);
            }
            
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to fetch attendance records';
            setError(errorMessage);
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleClearFilters = () => {
        setSelectedMonth(new Date().getMonth());
        setSelectedYear(new Date().getFullYear());
        setSelectedStatus('All');
        setFilteredRecords(records);
    };

    // FIXED: Date formatting without timezone issues
    const formatDate = (dateString: string) => {
        try {
            // Parse the date string directly without timezone conversion
            const [month, day, year] = dateString.split(' ');
            return `${month.slice(0, 3)} ${day.replace(',', '')}, ${year}`;
        } catch (error) {
            console.error("Error formatting date:", dateString, error);
            return dateString;
        }
    };

    // Calculate attendance statistics
    const totalDays = filteredRecords.length;
    const presentDays = filteredRecords.filter(record => record.status === 'Present').length;
    const absentDays = filteredRecords.filter(record => record.status === 'Absent').length;
    const partialDays = filteredRecords.filter(record => record.status === 'Partial').length;
    const leaveDays = filteredRecords.filter(record => record.status === 'Leave').length;
    const attendanceRate = totalDays > 0 ? (presentDays / totalDays * 100).toFixed(1) : 0;

    // Pagination calculations
    const totalPages = Math.ceil(filteredRecords.length / itemsPerPage);
    const paginatedRecords = filteredRecords.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    if (loading) {
        return (
            <div>
                <PageTitle title="My Attendance" subtitle="Track and manage your attendance records" />
                <Card className="text-center py-12">
                    <div className="animate-pulse text-gray-600">
                        <div className="w-8 h-8 bg-gray-300 rounded-full mx-auto mb-4"></div>
                        Loading attendance records...
                    </div>
                </Card>
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <PageTitle title="My Attendance" subtitle="Track and manage your attendance records" />
                <Card className="text-center py-8">
                    <div className="text-red-600 mb-4">
                        <svg className="w-12 h-12 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p className="text-lg font-semibold mb-2">Unable to load attendance</p>
                        <p className="text-sm text-gray-600">{error}</p>
                    </div>
                    <Button 
                        onClick={handleRetry} 
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                    >
                        Try Again
                    </Button>
                </Card>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <PageTitle 
                title="My Attendance" 
                subtitle={`Welcome ${traineeName || 'Trainee'} - Track and manage your attendance records`}
            />

            {/* Statistics Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 sm:gap-4">
                <Card className="p-4 text-center bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200">
                    <div className="text-2xl font-bold text-blue-700">{totalRecords}</div>
                    <div className="text-sm text-blue-600 font-medium">Total Records</div>
                </Card>
                <Card className="p-4 text-center bg-gradient-to-br from-green-50 to-green-100 border border-green-200">
                    <div className="text-2xl font-bold text-green-700">{presentDays}</div>
                    <div className="text-sm text-green-600 font-medium">Present</div>
                </Card>
                <Card className="p-4 text-center bg-gradient-to-br from-red-50 to-red-100 border border-red-200">
                    <div className="text-2xl font-bold text-red-700">{absentDays}</div>
                    <div className="text-sm text-red-600 font-medium">Absent</div>
                </Card>
                <Card className="p-4 text-center bg-gradient-to-br from-yellow-50 to-yellow-100 border border-yellow-200">
                    <div className="text-2xl font-bold text-yellow-700">{leaveDays}</div>
                    <div className="text-sm text-yellow-600 font-medium">Leave</div>
                </Card>
                <Card className="p-4 text-center bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200">
                    <div className="text-2xl font-bold text-purple-700">{attendanceRate}%</div>
                    <div className="text-sm text-purple-600 font-medium">Attendance Rate</div>
                </Card>
            </div>

            {/* Filters Section */}
            <Card className="p-4">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <div className="flex items-center gap-2">
                        <CalendarIcon />
                        <h3 className="text-lg font-semibold text-gray-800">Attendance Records</h3>
                        <span className="bg-gray-100 text-gray-600 px-2 py-1 rounded-full text-sm">
                            {filteredRecords.length} of {totalRecords} records
                        </span>
                        {isProgramCompleted && (
                            <span className="bg-green-100 text-green-700 px-2.5 py-1 rounded-full text-xs font-bold border border-green-200">
                                History Mode
                            </span>
                        )}
                    </div>
                    
                    <div className="flex flex-wrap gap-3">
                        <div className="flex items-center gap-2">
                            {!isProgramCompleted && (
                                <>
                                    <select
                                        value={selectedMonth}
                                        onChange={(e) => setSelectedMonth(Number(e.target.value))}
                                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                    >
                                        {months.map((month, index) => (
                                            <option key={month} value={index}>
                                                {month}
                                            </option>
                                        ))}
                                    </select>
                                    
                                    <select
                                        value={selectedYear}
                                        onChange={(e) => setSelectedYear(Number(e.target.value))}
                                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                    >
                                        {years.map(year => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>
                                </>
                            )}

                            <select
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm font-medium"
                            >
                                <option value="All">All Statuses</option>
                                <option value="Present">Present</option>
                                <option value="Absent">Absent</option>
                                <option value="Partial">Partial</option>
                                <option value="Leave">Leave</option>
                            </select>
                        </div>
                        
                        {(selectedStatus !== 'All' || !isProgramCompleted) && (
                            <Button
                                onClick={handleClearFilters}
                                variant="outline"
                                className="text-sm"
                            >
                                Clear Filters
                            </Button>
                        )}
                    </div>
                </div>
            </Card>

            {/* Attendance Table */}
            <Card className="overflow-hidden border border-gray-200">
                {filteredRecords.length === 0 ? (
                    <div className="text-center py-12">
                        <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <p className="text-gray-500 text-lg mb-2">No records found</p>
                        <p className="text-gray-400 text-sm">
                            {records.length === 0 
                                ? "No attendance records available." 
                                : "No records match the selected filters."}
                        </p>
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                            <thead className="bg-gray-50 border-b border-gray-200">
                                <tr>
                                    <th className="px-6 py-4 text-left font-semibold text-gray-700 text-xs uppercase tracking-wider">Date</th>
                                    <th className="px-6 py-4 text-left font-semibold text-gray-700 text-xs uppercase tracking-wider">Day</th>
                                    <th className="px-6 py-4 text-left font-semibold text-gray-700 text-xs uppercase tracking-wider">Start Time</th>
                                    <th className="px-6 py-4 text-left font-semibold text-gray-700 text-xs uppercase tracking-wider">End Time</th>
                                    <th className="px-6 py-4 text-left font-semibold text-gray-700 text-xs uppercase tracking-wider">Status</th>
                                    <th className="px-6 py-4 text-left font-semibold text-gray-700 text-xs uppercase tracking-wider">Reason</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                                {paginatedRecords.map((record, index) => (
                                    <tr 
                                        key={`${record.date}-${index}`} 
                                        className="hover:bg-gray-50 transition-colors duration-150"
                                    >
                                        <td className="px-6 py-4">
                                            <div className="font-medium text-gray-900 whitespace-nowrap">
                                                {formatDate(record.date)}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 text-gray-600">
                                            {record.day}
                                        </td>
                                        <td className="px-6 py-4 text-gray-600 font-mono">
                                            {record.startTime}
                                        </td>
                                        <td className="px-6 py-4 text-gray-600 font-mono">
                                            {record.endTime}
                                        </td>
                                        <td className="px-6 py-4">
                                            <StatusBadge status={record.status} />
                                        </td>
                                        <td className="px-6 py-4 text-gray-600 max-w-xs">
                                            <div className="truncate" title={record.reason}>
                                                {record.reason}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Card>

            {/* Pagination Controls */}
            {totalPages > 1 && (
                <div className="flex flex-col sm:flex-row justify-between items-center gap-4 py-4 px-1">
                    <div className="text-sm text-gray-500">
                        Showing <span className="font-semibold">{((currentPage - 1) * itemsPerPage) + 1}</span> to <span className="font-semibold">{Math.min(currentPage * itemsPerPage, filteredRecords.length)}</span> of <span className="font-semibold">{filteredRecords.length}</span> records
                    </div>
                    
                    <div className="flex items-center gap-1">
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            className="px-3 py-1.5 rounded-lg border border-gray-200 text-sm font-medium hover:bg-gray-50 disabled:opacity-50 disabled:bg-gray-50 transition-all flex items-center gap-1"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                            Prev
                        </button>
                        
                        <div className="hidden sm:flex items-center gap-1 mx-2">
                            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                // Simple sliding window for page numbers
                                let pageNum = 1;
                                if (totalPages <= 5) pageNum = i + 1;
                                else if (currentPage <= 3) pageNum = i + 1;
                                else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
                                else pageNum = currentPage - 2 + i;
                                
                                return (
                                    <button
                                        key={pageNum}
                                        onClick={() => setCurrentPage(pageNum)}
                                        className={`w-9 h-9 rounded-lg text-sm font-semibold transition-all ${currentPage === pageNum ? 'bg-primary text-white shadow-md' : 'text-gray-600 hover:bg-gray-100'}`}
                                    >
                                        {pageNum}
                                    </button>
                                );
                            })}
                        </div>
                        
                        <button
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                            className="px-3 py-1.5 rounded-lg border border-gray-200 text-sm font-medium hover:bg-gray-50 disabled:opacity-50 disabled:bg-gray-50 transition-all flex items-center gap-1"
                        >
                            Next
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AttendancePage;